import { injectToolCSS } from '../utils/cssGenerator'
import { LINKS_SELECTORS } from '../enum/Selectors'
import ToolConfig from '../types/ToolConfig'

export const highlightLinksConfig: ToolConfig = {
  id: 'highlight-links',
  selector: `html`,
  childrenSelector: LINKS_SELECTORS,
  styles: {
    outline: '2px solid #0048ff',
    'outline-offset': '2px',
  },
}

export default function highlightLinks(enable = false) {
  injectToolCSS({
    ...highlightLinksConfig,
    enable,
  })
}
